import { TableHeader } from 'cdk-radial';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { DownloadButton, PrintButton } from 'common/constants';
import { ExportOrArchiveDialog } from 'components/ExportOrArchiveDialog';
import { PrintViewer } from 'components/PrintViewer/PrintViewer';
import { usePrintButton } from 'hooks/usePrintButton';
import { TableHeaderType } from 'pages/VendorPaymentResultPage/interfaces';
import { labelMessages } from 'pages/VendorPaymentResultPage/messages';
import {
  IconCheckCircleStyle,
  PaymentDetailTableHeaderContentStyle,
  PaymentDetailTableHeaderStyle
} from 'pages/VendorPaymentResultPage/styled';
import { VendorPaymentDetails } from 'pages/VendorPaymentResultPage/types';

export const SuccessTableHeader = ({
  tableHeaderTitle,
  totalRecord,
  gridRef,
  columnDefs
}: TableHeaderType): React.JSX.Element => {
  const intl = useIntl();
  const { displayPrinter, onPrintClick, onClose } = usePrintButton();
  const [downloadClicked, setDownloadClicked] = useState<boolean>(false);

  const titleForExport = `${intl.formatMessage(
    labelMessages.paymentResultPageHeader
  )}-${tableHeaderTitle} (${totalRecord})`;

  const onDownloadClick = () => setDownloadClicked(true);

  const onDownloadClose = () => setDownloadClicked(false);

  return (
    <>
      {displayPrinter && (
        <PrintViewer<VendorPaymentDetails>
          gridRef={gridRef}
          open={displayPrinter}
          onClose={onClose}
          tableHeaderFilters={{ tableTitle: titleForExport }}
        />
      )}
      {downloadClicked && (
        <ExportOrArchiveDialog<VendorPaymentDetails>
          isOpen={downloadClicked}
          onClose={onDownloadClose}
          gridRef={gridRef}
          columnDefs={columnDefs}
          tableHeaderFilters={{ tableTitle: titleForExport }}
        />
      )}
      <TableHeader
        id="composed-table"
        headerTitle={
          <PaymentDetailTableHeaderStyle>
            <IconCheckCircleStyle />
            <PaymentDetailTableHeaderContentStyle>
              {`${tableHeaderTitle}(${totalRecord})`}
            </PaymentDetailTableHeaderContentStyle>
          </PaymentDetailTableHeaderStyle>
        }
        onDownloadClick={onDownloadClick}
        onPrintClick={onPrintClick}
        downloadButtonText={DownloadButton.SuccessFileDownload}
        printButtonText={PrintButton.SuccessFilePrint}
        isSearchable={false}
      />
    </>
  );
};
